import { createAction } from '@reduxjs/toolkit';

export const boundaryTerritoryGroupHighlightStarted = createAction('BOUNDARY_TERRITORY_GROUP_HIGHLIGHT_STARTED',
  (boundaryGroupId: number) => ({
    payload: {
      boundaryGroupId,
    },
  }),
);
export const boundaryTerritoryGroupInSidebarHighlightFinished =
  createAction('BOUNDARY_TERRITORY_GROUP_IN_SIDEBAR_HIGHLIGHT_FINISHED');
